import { AfterCustomerOrderLineConfigurationCreatedViewProps } from "src/tenantCustomizations/TenantCustomizations.ts";
import { PartConfigurationDetailsViewApi } from "src/api/generated/erp/configurator/api/partConfigurationDetailsViewApi.ts";
import { CustomerOrderLineApi } from "src/api/generated/erp/sales/customerOrder/api/customerOrderLineApi.ts";
import { CustomerOrderChangeForm } from "src/components/views/erp/sales/customerOrderChange/CustomerOrderChangeForm.tsx";
import { AsyncFetchRender } from "../../../../components/common/async/AsyncFetchRender.tsx";
import { round } from "../../../../utils/numberUtils.ts";

export const SalvosAfterCustomerOrderLineConfigurationCreatedView = ({
	customerOrderId,
	customerOrderLineId,
	newPartConfigurationId,
	oldPartConfigurationId,
	historyEntryInput,
	onCompleted,
}: AfterCustomerOrderLineConfigurationCreatedViewProps) => {
	return (
		<AsyncFetchRender
			fetch={async () => {
				const newConfigPromise = PartConfigurationDetailsViewApi.getPartConfiguration({
					partConfigurationId: newPartConfigurationId,
				});
				const oldConfigPromise =
					oldPartConfigurationId != null ?
						PartConfigurationDetailsViewApi.getPartConfiguration({
							partConfigurationId: oldPartConfigurationId,
						})
					:	Promise.resolve(undefined);
				const customerOrderLinePromise = CustomerOrderLineApi.getCustomerOrderLine({
					customerOrderLineId,
				});
				const [newConfig, oldConfig, customerOrderLine] = await Promise.all([
					newConfigPromise,
					oldConfigPromise,
					customerOrderLinePromise,
				]);
				return { newConfig, oldConfig, customerOrderLine };
			}}
			content={({ newConfig, oldConfig, customerOrderLine }) => {
				const priceChange = newConfig.salesPrice - (oldConfig?.salesPrice ?? 0);
				const priceChangeMaybeWithVat =
					customerOrderLine.priceInputWithVat ?
						calculatePriceWithVat(priceChange, customerOrderLine.vatPercentFactor)
					:	priceChange;

				return (
					<CustomerOrderChangeForm
						objectType="CUSTOMER_ORDER"
						objectId={customerOrderId}
						existingCustomerOrderChange={undefined}
						defaultValueOverrides={{
							subject: "",
							content: historyEntryInput.comment.split("\n").join("<br/>"),
							costChange: round(newConfig.totalCost - (oldConfig?.totalCost ?? 0), 2),
							priceChange: round(priceChangeMaybeWithVat, 2),
						}}
						onCompleted={onCompleted}
					/>
				);
			}}
		/>
	);
};

function calculatePriceWithVat(price: number, vatPercentFactor: number | undefined | null) {
	return price * (1 + (vatPercentFactor ?? 0));
}
